export default function NotFoundPage() {
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, we couldn't find the designer you wanted.</p>
    </div>
  );
}
